exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Popup__root {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  z-index: 1002;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 242px;\r\n  padding: 16px;\r\n  background: rgba(34, 42, 55, 0.6);\r\n  border-radius: 12px;\r\n  box-shadow: 0px 8px 16px rgba(34, 42, 55, 0.13);\r\n  -webkit-transform: translate(-50%, -50%);\r\n          transform: translate(-50%, -50%);\r\n}\r\n\r\n.DS__Popup__icon {\r\n  color:  #97ba1e;\r\n}\r\n\r\n.DS__Popup__text {\r\n  margin-left: 12px;\r\n  color: #ffffff;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"root": "DS__Popup__root",
	"icon": "DS__Popup__icon",
	"text": "DS__Popup__text"
};